module.exports = __webpack_public_path__ + "7438fe53634e47775cf7ed72ce7d428f.jpg";